var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3671892UploadIconfinder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10v6H7v-6H2l8-8 8 8h-5zM0 18h20v2H0v-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3671892UploadIconfinder);
export default __webpack_public_path__ + "static/media/3671892_upload_iconfinder.0e9f0d8e76a8d60419104804355fd309.svg";
export { ForwardRef as ReactComponent };